import { getImageProps } from "next/image";
import React, { FC } from "react";

import Image from "@/components/ui/Image/Image";

import { CardWidthModal } from "./VerticalCardSlideShow";

const CardVerticalSlider: FC<CardWidthModal> = (cardData) => {
  return (
    <div className="md:w-full md:relative aspect-3-4 md:rounded-md md:overflow-hidden">
      <Image
        alt={cardData?.image?.title || ""}
        className="rounded aspect-3-4 shadow-strong h-full w-full"
        src={cardData?.image?.url}
        width={400}
        height={532}
      />
      <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-2"></div>
      <Image
        className="absolute mx-auto left-1/2 transform -translate-x-1/2 bottom-m filter invert w-[100px] h-[80px] "
        src={cardData?.logo?.url}
        alt={cardData?.logo?.title}
        width={100}
        height={80}
        fit="pad"
      />
    </div>
  );
};
export default CardVerticalSlider;
